import React, {
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputAdornment,
  Input,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Fab,
} from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'dva';
import { Context } from '../../index';
import TitleML from '../TitleML/TitleML';
import DateRangePickerML from '@/components/DateRangePickerML';
import NumberFormatML from '@/components/NumberFormatML';
import request from '@/utils/request';
import { download } from '@/utils/downloadUtil';

const NumberFormatCustom = React.forwardRef((props, ref) => (
  <NumberFormatML {...props} allowNegative={false} ref={ref} />
));

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}

const getFileName = (str) => {
  const startIndex = str.indexOf('/') + 1;
  const endIndex = str.lastIndexOf('_');
  const middleContent = str.substring(startIndex, endIndex);

  // 拼接点号后面的内容
  const dotIndex = str.lastIndexOf('.') + 1;
  const extension = str.substring(dotIndex);
  if (!middleContent) {
    return str;
  }
  const result = middleContent + '.' + extension;
  return result;
};

export default React.forwardRef(
  (
    {
      onSubmitSuccess,
      queryType = null,
      cType,
      handleResetForm,
      formatMessage,
    },
    // eslint-disable-next-line no-unused-vars
    fref,
  ) => {
    const { control, handleSubmit, errors, setValue, getValues, watch } =
      useForm();
    const [couponGetCheckboxState, setCouponGetCheckboxState] = useState();
    const [couponGetStartTypeState, setCouponGetStartTypeState] = useState();
    const [focusStatus, setFocusStatus] = useState(false);
    const [couponUsingThresholdState, setCouponUsingThresholdState] =
      useState();
    const [recipientRestrictionState, setRecipientRestrictionState] =
      useState();
    const [limitGetNumberRadioState, setLimitGetNumberRadioState] = useState();
    const [shareSettingStatusState, setShareSettingStatusState] = useState();
    const [turnAddStatusState, setTurnAddStatusState] = useState();
    const [couponConditionsOneState, setCouponConditionsOneState] = useState();
    const [couponConditionsTwoState, setCouponConditionsTwoState] = useState();
    const [couponConditionsThreeState, setCouponConditionsThreeState] =
      useState();
    const [couponConditionsFourState, setCouponConditionsFourState] =
      useState();
    const [couponConditionsFiveState, setCouponConditionsFiveState] =
      useState();
    const [couponConditionsSixState, setCouponConditionsSixState] = useState();
    const [couponConditionsSevenState, setCouponConditionsSevenState] =
      useState();
    const { stepOneData } = useSelector((state) => state.couponsSetting);

    const [fileList, setFileList] = useState([]);
    const { ref } = useContext(Context);
    const submitRef = useRef();
    const clickInput = () => {
      submitRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInput,
    }));

    useEffect(() => {
      setValue(
        'couponGetCheckbox',
        Boolean(
          Number(stepOneData.validDays) && Number(stepOneData.validDays) > 0,
        ),
      ); //领券checkbox
      setValue('couponUsingThreshold', stepOneData.transactionMinimum); //使用门槛
      setValue('validBegin', stepOneData.validBegin); //领券select
      setValue('memberLimit', String(stepOneData.memberLimit)); //领取人限制radio
      setValue('isLimitMaxCoupons', String(stepOneData.isLimitMaxCoupons)); //每人限领次数开关
      setValue('canShare', stepOneData.canShare); //分享设置
      setValue('transferable', stepOneData.transferable); //转增设置
      setValue('isOver', !stepOneData.isOver); //使用条件1
      setValue('isMemberDiscount', !stepOneData.isMemberDiscount); //使用条件2
      setValue('isActivityOver', !stepOneData.isActivityOver); //使用条件3
      setValue('isNonPositive', !stepOneData.isNonPositive); //使用条件4
      setValue('isStaff', stepOneData.isStaff); //使用条件5
      setValue('isPoint', stepOneData.isPoint); //使用条件6
      setValue('isRank', stepOneData.isRank); //使用条件7
      setValue('title', stepOneData.title); //标题
      setValue('subTitle', stepOneData.subTitle); //副标题
      setValue('comment', stepOneData.comment); //优惠券备注
      setValue('quantity', stepOneData.quantity); //发放总量
      setValue('transactionMinimum', stepOneData.transactionMinimum); //金额
      setValue('discountAmount', stepOneData.discountAmount); //优惠减免
      setValue('maxCouponsPerUser', stepOneData.maxCouponsPerUser); //每人限领次数
      setValue('goodsNum', stepOneData.goodsNum); //限制订单内商品件数
      setValue('description', stepOneData.description); //说明
      setValue('validDays', stepOneData.validDays); //天
      setValue('discountPercent', stepOneData.discountPercent); //折扣比例
      setValue('gift', stepOneData.gift); //商品描述

      if (stepOneData.thirdFilePath) {
        setValue('thirdFilePath', stepOneData.thirdFilePath);
        setFileList(JSON.parse(stepOneData.thirdFilePath));
      }

      setValue('date', {
        startDate: stepOneData.beginTime,
        endDate: stepOneData.endTime,
      });
    }, [
      stepOneData.memberLimit,
      stepOneData.transactionMinimum,
      stepOneData.couponGetCheckbox,
      stepOneData.validBegin,
      stepOneData.isLimitMaxCoupons,
      stepOneData.canShare,
      stepOneData.transferable,
      stepOneData.isOver,
      stepOneData.isMemberDiscount,
      stepOneData.isActivityOver,
      stepOneData.isNonPositive,
      stepOneData.isStaff,
      stepOneData.isPoint,
      stepOneData.isRank,
      stepOneData.validDays,
      stepOneData.title,
      stepOneData.subTitle,
      stepOneData.comment,
      stepOneData.quantity,
      stepOneData.discountAmount,
      stepOneData.maxCouponsPerUser,
      stepOneData.goodsNum,
      stepOneData.description,
      stepOneData.beginTime,
      stepOneData.endTime,
      stepOneData.discountPercent,
      stepOneData.gift,
      stepOneData.thirdFilePath,
      setValue,
      cType,
    ]);
    const deCouponGetCheckboxState = Boolean(
      Number(stepOneData.validDays) && Number(stepOneData.validDays) > 0,
    );
    const deCouponUsingThresholdState =
      Number(stepOneData.transactionMinimum) !== 0;
    const deCouponGetStartTypeState = stepOneData.validBegin;
    const deRecipientRestrictionState = String(stepOneData.memberLimit);
    const deLimitGetNumberRadioState = String(stepOneData.isLimitMaxCoupons);
    const deShareSettingStatusState = stepOneData.canShare;
    const deTurnAddStatusState = stepOneData.transferable;
    const deCouponConditionsOneState = !stepOneData.isOver;
    const deCouponConditionsTwoState = !stepOneData.isMemberDiscount;
    const deCouponConditionsThreeState = !stepOneData.isActivityOver;
    const deCouponConditionsFourState = !stepOneData.isNonPositive;
    const deCouponConditionsFiveState = stepOneData.isStaff;
    const deCouponConditionsSixState = stepOneData.isPoint;
    const deCouponConditionsSevenState = stepOneData.isRank;
    const couponUsingThreshold = ({
      field,
      unit,
      required = false,
      message,
      disabled = false,
      inputType = '',
    }) => {
      if (inputType === 'amount') {
        return (
          <Box className="amount-input-style text-input-align-style ">
            <Controller
              render={(pr) => (
                <TextField
                  value={pr.value ?? stepOneData[field]}
                  onChange={(e) => {
                    return pr.onChange(e.target.value);
                  }}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                      <InputAdornment position="end">{unit}</InputAdornment>
                    ),
                  }}
                  variant="standard"
                  disabled={disabled || queryType === 'detail'}
                  error={Boolean(errors[field]) && required}
                />
              )}
              control={control}
              name={field}
              rules={{
                required,
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box className="input-error-style">
              {errors[field] ? message : ''}
            </Box>
          </Box>
        );
      }
      return (
        <Box>
          <Controller
            render={(pr) => (
              <Input
                id="outlined-multiline-static"
                value={pr.value ?? ''}
                autoComplete="off"
                className="text-input-style text-input-align-style"
                endAdornment={
                  <InputAdornment position="end">{unit}</InputAdornment>
                }
                aria-describedby="standard-weight-helper-text"
                onChange={(e) => {
                  return pr.onChange(e.target.value);
                }}
                error={Boolean(errors[field]) && required}
                type="number"
                disabled={disabled || queryType === 'detail'}
              />
            )}
            control={control}
            name={field}
            rules={{
              required,
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box className="input-error-style">
            {errors[field] ? message : ''}
          </Box>
        </Box>
      );
    };

    // 上传文件
    const uploadFile = (file) => {
      const checkFormData = new FormData();
      checkFormData.append('quantity', getValues('quantity'));
      checkFormData.append('file', file[0]);
      request('/coupon/checkThirdCardFile', {
        method: 'POST',
        data: checkFormData,
      })
        .then(() => {
          const formData = new FormData();
          formData.append('file', file[0]);
          formData.append('isFixedName', true);
          formData.append('isPublic', false);
          formData.append('bucket', 'THREE-WAY-COUPON-FILE');
          const fileName = file[0].name; //文件名 MemberBlackTemplate.csv
          request('/common/upload', {
            method: 'POST',
            data: formData,
          })
            .then((res) => {
              if (res.code === 0) {
                const fileObj = { id: guid(), ...res.data, fileName };
                setFileList([fileObj]);
                document.getElementById('inputFile').value = null;
                setValue('thirdFilePath', JSON.stringify([fileObj]));
              } else {
                window.message.toast({
                  type: 'error',
                  message: res.message,
                  title: '失败',
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          document.getElementById('inputFile').value = null;
        });
    };

    //删除文件
    const handleFileListDelete = ({ selfId }) => {
      const list = fileList.filter((item) => item.id !== selfId);
      setFileList([...list]);
      setValue('thirdFilePath', list.length > 0 ? JSON.stringify(list) : '');
    };
    // 下载模版
    const handleClickDownload = () => {
      if (queryType === 'detail') {
        return;
      }
      download('/common/importThirdCardTemplate');
    };
    return (
      <Box className="step-form-wrap">
        <form onSubmit={handleSubmit(onSubmitSuccess)}>
          <Box display="flex">
            {/*左侧*/}
            <Box flex="1" pl={7}>
              <Box>
                <TitleML
                  title={formatMessage({ id: 'coupon.mgt.volume.n01.lbl01' })}
                  fontSize="19px"
                />
                <Box>
                  {/*优惠券名称*/}
                  <Box width="100%" maxWidth="333px" mt={8}>
                    <Controller
                      render={(pr) => (
                        <TextField
                          variant="standard"
                          id="outlined-multiline-static"
                          autoComplete="off"
                          label={
                            <>
                              <span style={{ color: 'red' }}>*</span>{' '}
                              {formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl02',
                              })}
                            </>
                          }
                          value={pr.value || ''}
                          placeholder={formatMessage({
                            id: 'coupon.mgt.volume.n01.placeholder03',
                          })}
                          className="text-input-style"
                          onChange={(e) => {
                            return pr.onChange(e.target.value);
                          }}
                          error={Boolean(errors.title)}
                          helperText={
                            errors.title
                              ? formatMessage({
                                  id: 'coupon.mgt.n03.lbl02',
                                })
                              : ''
                          }
                          disabled={queryType === 'detail'}
                        />
                      )}
                      control={control}
                      name="title"
                      rules={{
                        required: true,
                      }}
                    />
                  </Box>
                  {/*优惠券副标题*/}
                  <Box width="100%" maxWidth="333px" mt={5}>
                    <Controller
                      render={(pr) => (
                        <TextField
                          variant="standard"
                          id="outlined-multiline-static"
                          autoComplete="off"
                          label={
                            <>
                              <span style={{ color: 'red' }}>*</span>{' '}
                              {formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl04',
                              })}
                            </>
                          }
                          value={pr.value || ''}
                          placeholder={formatMessage({
                            id: 'coupon.mgt.volume.n01.placeholder05',
                          })}
                          className="text-input-style"
                          onChange={(e) => {
                            return pr.onChange(e.target.value);
                          }}
                          error={Boolean(errors.subTitle)}
                          helperText={
                            errors.subTitle
                              ? formatMessage({
                                  id: 'coupon.mgt.n03.lbl04',
                                })
                              : ''
                          }
                          disabled={queryType === 'detail'}
                        />
                      )}
                      control={control}
                      name="subTitle"
                      rules={{
                        required: true,
                      }}
                    />
                  </Box>
                  {/*优惠券备注*/}
                  <Box width="100%" maxWidth="333px" mt={5}>
                    <Controller
                      render={(pr) => (
                        <TextField
                          variant="standard"
                          id="outlined-multiline-static"
                          autoComplete="off"
                          label={
                            <>
                              {formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl06',
                              })}
                            </>
                          }
                          value={pr.value || ''}
                          placeholder={formatMessage({
                            id: 'coupon.mgt.volume.n01.placeholder07',
                          })}
                          className="text-input-style"
                          onChange={(e) => {
                            return pr.onChange(e.target.value);
                          }}
                          disabled={queryType === 'detail'}
                        />
                      )}
                      control={control}
                      name="comment"
                    />
                  </Box>
                  {/*发放总量*/}
                  <Box width="100%" maxWidth="333px" mt={5}>
                    <Controller
                      render={(pr) => (
                        <TextField
                          variant="standard"
                          id="outlined-multiline-static"
                          autoComplete="off"
                          label={
                            <>
                              <span style={{ color: 'red' }}>*</span>{' '}
                              {formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl08',
                              })}
                            </>
                          }
                          value={pr.value}
                          placeholder={formatMessage({
                            id: 'coupon.mgt.volume.n01.placeholder09',
                          })}
                          className="text-input-style text-input-align-style"
                          onChange={(e) => {
                            return pr.onChange(e.target.value);
                          }}
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                          error={Boolean(errors.quantity)}
                          helperText={
                            errors.quantity
                              ? formatMessage({
                                  id: 'coupon.mgt.n03.lbl07',
                                })
                              : ''
                          }
                          // type="number"
                          // InputLabelProps={
                          //   {
                          //     // shrink: true,
                          //   }
                          // }
                          disabled={queryType === 'detail'}
                        />
                      )}
                      control={control}
                      name="quantity"
                      rules={{
                        required: true,
                      }}
                    />
                  </Box>
                  {/*使用门槛*/}
                  <Box width="100%" mt={5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      <span style={{ color: 'red' }}>*</span>{' '}
                      {formatMessage({
                        id: 'coupon.mgt.volume.n01.rdo10',
                      })}
                    </Box>
                    <Box display="flex">
                      <Controller
                        render={(pr) => (
                          <RadioGroup
                            className="checkbox-radio-disabled-color"
                            aria-label="couponUsingThresholdState"
                            onChange={(e) => {
                              setCouponUsingThresholdState(
                                e.target.value === 'true',
                              );
                              e.target.value !== 'true' &&
                                setValue('transactionMinimum', 0);
                              return pr.onChange(e.target.value);
                            }}
                            value={
                              couponUsingThresholdState ??
                              deCouponUsingThresholdState
                            }
                          >
                            <Box display="flex" gap="0 53px">
                              <Box display="flex">
                                <FormControlLabel
                                  variant="standard"
                                  value={false}
                                  control={<Radio />}
                                  label={
                                    <Box
                                      width="80px"
                                      color="#000"
                                      lineHeight="1"
                                    >
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n01.lbl11',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                              <Box>
                                <FormControlLabel
                                  variant="standard"
                                  value={true}
                                  control={<Radio />}
                                  label={
                                    <Box
                                      width="50px"
                                      color="#000"
                                      lineHeight="1"
                                    >
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n01.lbl12',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                            </Box>
                          </RadioGroup>
                        )}
                        control={control}
                        name="couponUsingThreshold"
                      />
                      <Box maxWidth="140px" display="flex" alignItems="center">
                        {couponUsingThreshold({
                          field: 'transactionMinimum',
                          unit: formatMessage({ id: 'comm.amount.lbl.01' }),
                          required:
                            couponUsingThresholdState ??
                            deCouponUsingThresholdState,
                          message:
                            couponUsingThresholdState ??
                            deCouponUsingThresholdState
                              ? formatMessage({
                                  id: 'coupon.mgt.n03.lbl08',
                                })
                              : '',
                          disabled: !(
                            couponUsingThresholdState ??
                            deCouponUsingThresholdState
                          ),
                          defaultValue: 0,
                          inputType: 'amount',
                        })}
                      </Box>
                      <Box
                        color="#000"
                        fontSize="14px"
                        ml={1.125}
                        lineHeight="40px"
                      >
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt46',
                        })}
                      </Box>
                    </Box>
                  </Box>
                  {/*优惠内容cType === '2'满减*/}
                  {cType === '2' && (
                    <Box width="100%" mt={5} key="ct00">
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        <span style={{ color: 'red' }}>*</span>{' '}
                        {formatMessage({
                          id: 'coupon.mgt.volume.n01.lbl14',
                        })}
                      </Box>
                      <Box display="flex" alignItems="center" key="1">
                        <Box color="#000" fontSize="14px" mr={0.75}>
                          {formatMessage({
                            id: 'coupon.mgt.volume.n01.lbl15',
                          })}
                        </Box>
                        <Box maxWidth="140px">
                          {couponUsingThreshold({
                            field: 'discountAmount',
                            unit: formatMessage({ id: 'comm.amount.lbl.01' }),
                            required: true,
                            message: formatMessage({
                              id: 'coupon.mgt.pricevalue.n01.txt47',
                            }),
                            inputType: 'amount',
                          })}
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {/* 满足件数  满折*/}
                  {cType === '3' && (
                    <Box width="100%" maxWidth="333px" mt={5}>
                      <Controller
                        render={(pr) => (
                          <TextField
                            variant="standard"
                            id="outlined-multiline-static"
                            autoComplete="off"
                            label={
                              <>
                                <span style={{ color: 'red' }}>*</span>{' '}
                                {formatMessage({
                                  id: 'coupon.mgt.pricequantity.n01.lbl12',
                                })}
                              </>
                            }
                            value={pr.value || ''}
                            placeholder={formatMessage({
                              id: 'coupon.mgt.pricequantity.n01.lbl13',
                            })}
                            className="text-input-style text-input-align-style"
                            onChange={(e) => {
                              return pr.onChange(e.target.value);
                            }}
                            error={Boolean(errors.goodsNum)}
                            helperText={
                              errors.goodsNum
                                ? formatMessage({
                                    id: 'coupon.mgt.pricevalue.n01.txt48',
                                  })
                                : ''
                            }
                            type="number"
                            InputLabelProps={
                              {
                                // shrink: true,
                              }
                            }
                            disabled={queryType === 'detail'}
                          />
                        )}
                        control={control}
                        name="goodsNum"
                        rules={{
                          // required: true,
                          validate: () => {
                            if (getValues('goodsNum') <= 0) {
                              return false;
                            }
                          },
                        }}
                      />
                    </Box>
                  )}
                  {/*优惠内容cType === '1'折扣*/}
                  {(cType === '1' || cType === '3') && (
                    <Box width="100%" maxWidth="333px" mt={5} key="ct01">
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        <span style={{ color: 'red' }}>*</span>{' '}
                        {formatMessage({
                          id: 'coupon.mgt.pricequantity.n01.lbl14',
                        })}
                      </Box>
                      <Box display="flex" alignItems="flex-end" key="2">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              label=""
                              className="step-input-style text-input-align-style "
                              control={
                                <Box
                                  className={
                                    queryType === 'detail'
                                      ? 'disabled-input-style'
                                      : focusStatus
                                      ? 'step-input-focus-style step-input-hover-style'
                                      : 'step-input-hover-style'
                                  }
                                >
                                  <input
                                    type="number"
                                    step="0.01"
                                    value={
                                      pr.value ?? stepOneData.discountPercent
                                    }
                                    onFocus={() => {
                                      setFocusStatus(true);
                                    }}
                                    onBlur={() => {
                                      setFocusStatus(false);
                                    }}
                                    placeholder={formatMessage({
                                      id: 'coupon.mgt.pricevalue.n01.txt49',
                                    })}
                                    onChange={(e) => {
                                      return pr.onChange(e.target.value);
                                    }}
                                    disabled={queryType === 'detail'}
                                  />
                                </Box>
                              }
                            />
                          )}
                          control={control}
                          name="discountPercent"
                          rules={{
                            required: true,
                            max: 1,
                            min: 0,
                          }}
                        />
                        <Box whiteSpace="nowrap" color="#000" ml={0.5}>
                          {formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.lbl13',
                          })}
                        </Box>
                      </Box>
                      <Box className="input-error-style">
                        {errors.discountPercent &&
                          errors.discountPercent.type !== 'max' &&
                          formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt50',
                          })}
                      </Box>
                      {/* <FormHelperText
                        error={Boolean(
                          errors.discountPercent?.type==='max',
                        )}
                      >
                        {Boolean(
                          errors.discountPercent?.type==='max',
                        ) && '折扣比例不得大于1'}
                      </FormHelperText> */}
                      <FormHelperText
                        error={Boolean(getValues('discountPercent') > 1)}
                      >
                        {getValues('discountPercent') > 1 &&
                          formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt51',
                          })}
                      </FormHelperText>
                    </Box>
                  )}
                  {/*兑换券*/}
                  {(cType === '4' || cType === '8') && (
                    <Box width="100%" maxWidth="333px" mt={5} key="ct02">
                      <Controller
                        render={(pr) => (
                          <TextField
                            key="ct002"
                            multiline
                            rows={4}
                            id="outlined-multiline-static"
                            label={
                              <>
                                <span style={{ color: 'red' }}>*</span>{' '}
                                {formatMessage({
                                  id: 'coupon.mgt.exchange.n01.lbl12',
                                })}
                              </>
                            }
                            value={pr.value ?? stepOneData.gift}
                            placeholder={formatMessage({
                              id: 'coupon.mgt.exchange.n05.lbl01',
                            })}
                            className="text-input-style textField-area-wrap"
                            onChange={(e) => {
                              return pr.onChange(e.target.value);
                            }}
                            variant="outlined"
                            error={Boolean(errors.gift)}
                            helperText={
                              errors.gift
                                ? formatMessage({
                                    id: 'coupon.mgt.exchange.n05.lbl02',
                                  })
                                : ''
                            }
                            disabled={queryType === 'detail'}
                          />
                        )}
                        control={control}
                        name="gift"
                        rules={{
                          required: true,
                        }}
                      />
                    </Box>
                  )}
                  {/*tips*/}
                  <Box
                    color="#C9C9C9"
                    fontSize="14px"
                    fontWeight="400"
                    mt={1.75}
                  >
                    {formatMessage({ id: 'coupon.mgt.volume.n01.txt17' })}
                  </Box>
                  {/*用券时间*/}
                  <Box width="100%" mt={5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      <span style={{ color: 'red' }}>*</span>{' '}
                      {formatMessage({
                        id: 'coupon.mgt.volume.n01.lbl18',
                      })}
                    </Box>
                    <Box>
                      <FormControl variant="standard">
                        <Controller
                          render={(rp) => (
                            <DateRangePickerML
                              label={formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl18',
                              })}
                              title={formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl18',
                              })}
                              startText={formatMessage({
                                id: 'coupon.mgt.volume.n01.rdo19',
                              })}
                              endText={formatMessage({
                                id: 'coupon.mgt.volume.n01.rdo20',
                              })}
                              defaultStartDate={stepOneData.beginTime}
                              defaultEndDate={stepOneData.endTime}
                              rp={rp}
                              setValue={setValue}
                              name="custom-form-submit-name"
                              disabled={queryType === 'detail'}
                            />
                          )}
                          name="date"
                          control={control}
                          rules={{
                            validate: () => {
                              const status = !(
                                getValues('date').startDate === null ||
                                getValues('date').endDate === null
                              );
                              return status;
                            },
                          }}
                        />
                      </FormControl>
                    </Box>
                    {errors.date && (
                      <Box mt={1}>
                        <Box className="input-error-style">
                          {formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt54',
                          })}
                        </Box>
                      </Box>
                    )}
                  </Box>
                  {/*领券*/}
                  <Box display="flex" mt={5}>
                    <Box className="checkbox-radio-disabled-color">
                      <Controller
                        render={(pr) => (
                          <FormControlLabel
                            variant="standard"
                            checked={
                              couponGetCheckboxState ?? deCouponGetCheckboxState
                            }
                            control={<Checkbox color="primary" />}
                            label={
                              <Box width="35px" color="#000">
                                {formatMessage({
                                  id: 'coupon.mgt.volume.n01.chb21',
                                })}
                              </Box>
                            }
                            onChange={(e) => {
                              !e.target.checked &&
                                handleResetForm('validDays', '');

                              !e.target.checked && setValue('validDays', '');
                              setCouponGetCheckboxState(e.target.checked);
                              return pr.onChange(e.target.checked);
                            }}
                            disabled={queryType === 'detail'}
                          />
                        )}
                        control={control}
                        name="couponGetCheckbox"
                      />
                    </Box>
                    <Box width="84px">
                      <Controller
                        render={(pr) => (
                          <FormControl
                            variant="standard"
                            className="select-wrap-style"
                            disabled={queryType === 'detail'}
                          >
                            <Select
                              onChange={(e) => {
                                setCouponGetStartTypeState(e.target.value);
                                return pr.onChange(e.target.value);
                              }}
                              // label="表名"
                              value={
                                couponGetStartTypeState ??
                                deCouponGetStartTypeState
                              }
                            >
                              <MenuItem value={0}>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt55',
                                })}
                              </MenuItem>
                              <MenuItem value={1}>
                                {formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt56',
                                })}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        )}
                        control={control}
                        name="validBegin"
                      />
                    </Box>
                    <Box
                      color="#000"
                      fontSize="14px"
                      ml={1.75}
                      mr={1.75}
                      lineHeight="40px"
                    >
                      {formatMessage({
                        id: 'coupon.mgt.pricevalue.n01.txt57',
                      })}
                    </Box>
                    <Box width="84px" display="flex" alignItems="center">
                      {couponUsingThreshold({
                        field: 'validDays',
                        unit: formatMessage({ id: 'comm.date.lbl.01' }),
                        required:
                          couponGetCheckboxState ?? deCouponGetCheckboxState,
                        disabled:
                          !(
                            couponGetCheckboxState ?? deCouponGetCheckboxState
                          ) || queryType === 'detail',
                        message:
                          couponGetCheckboxState ?? deCouponGetCheckboxState
                            ? formatMessage({
                                id: 'coupon.mgt.pricevalue.n01.txt58',
                              })
                            : '',
                        inputType: 'amount',
                      })}
                    </Box>
                    <Box
                      color="#000"
                      fontSize="14px"
                      ml={1.125}
                      lineHeight="40px"
                    >
                      {formatMessage({
                        id: 'coupon.mgt.pricevalue.n01.txt46',
                      })}
                    </Box>
                  </Box>
                  {/* 三方券导入 */}

                  <Box
                    mt={5}
                    sx={{
                      display:
                        cType === '8' && watch('quantity') ? 'block' : 'none',
                    }}
                  >
                    <Box
                      color="#000"
                      fontSize="14px"
                      fontWeight="400"
                      mt={1.75}
                    >
                      三方券导入
                    </Box>
                    <div className="export-wrapper" style={{ marginTop: 12 }}>
                      <Fab
                        variant="extended"
                        size="small"
                        color={queryType === 'detail' ? '#fff' : 'primary'}
                        aria-label="add"
                        className="download"
                        sx={{ mr: 1.6 }}
                        onClick={handleClickDownload}
                        disabled={queryType === 'detail' ? 'disabled' : null}
                      >
                        <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
                        下载样例
                      </Fab>
                      <Fab
                        variant="extended"
                        size="small"
                        color={queryType === 'detail' ? '#fff' : 'primary'}
                        aria-label="add"
                        className="uploadFile"
                        sx={{ position: 'relative' }}
                        disabled={queryType === 'detail' ? 'disabled' : null}
                      >
                        <Controller
                          render={() => {
                            return (
                              <input
                                className="fileInput"
                                name="thirdFilePath"
                                style={{
                                  position: 'absolute',
                                  left: '0px',
                                  top: '0px',
                                  opacity: 0,
                                }}
                                disabled={queryType === 'detail'}
                                type="file"
                                id="inputFile"
                                accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                label="上传文件"
                                onChange={(e) => {
                                  // setFileName(e.target.value); //"C:\fakepath\MemberBlackTemplate.csv"
                                  let file = e.target.files;

                                  if (file) {
                                    uploadFile(file);
                                  }
                                  // return rp.onChange(e);
                                }}
                              />
                            );
                          }}
                          name="thirdFilePath"
                          type="file"
                          label="上传文件"
                          control={control}
                          rules={{ required: cType === '8' }}
                        />
                        <UnarchiveIcon sx={{ width: '24px', height: '24px' }} />
                        上传文件
                      </Fab>
                      <FormHelperText
                        error={Boolean(errors.thirdFilePath)}
                        sx={{ marginTop: '8px' }}
                      >
                        {Boolean(errors?.thirdFilePath?.type === 'required') &&
                          '请上传文件'}
                      </FormHelperText>
                    </div>
                    {fileList &&
                      fileList.map((item) => {
                        return (
                          <Box
                            className="file_name"
                            mt={2.6}
                            style={{
                              color: '##1565c0',
                            }}
                            key={item.id}
                          >
                            <span
                              style={{
                                cursor: 'pointer',
                              }}
                            >
                              {item.fileName && getFileName(item.fileName)}
                            </span>
                            {queryType === 'detail' ? (
                              ''
                            ) : (
                              <HighlightOffIcon
                                sx={{
                                  width: '24px',
                                  height: '24px',
                                  color: 'rgba(0, 0, 0, 0.26)',
                                  marginLeft: '9px',
                                  cursor: 'pointer',
                                  verticalAlign: 'middle',
                                }}
                                key={item.id}
                                onClick={() => {
                                  handleFileListDelete({ selfId: item.id });
                                }}
                              />
                            )}
                          </Box>
                        );
                      })}
                  </Box>
                </Box>
              </Box>
            </Box>
            {/*右侧*/}
            <Box flex="1">
              <Box>
                <TitleML
                  title={formatMessage({
                    id: 'coupon.mgt.volume.n01.lbl23',
                  })}
                  fontSize="19px"
                />
                <Box>
                  {/*领取人限制*/}
                  <Box width="100%" mt={7.5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      <span style={{ color: 'red' }}>*</span>{' '}
                      {formatMessage({ id: 'coupon.mgt.volume.n01.rdo24' })}
                    </Box>
                    <Box display="flex">
                      <Controller
                        render={(pr) => (
                          <RadioGroup
                            className="checkbox-radio-disabled-color"
                            aria-label="couponUsingThreshold"
                            onChange={(e) => {
                              setRecipientRestrictionState(e.target.value);
                              return pr.onChange(e.target.value);
                            }}
                            value={
                              recipientRestrictionState ??
                              deRecipientRestrictionState
                            }
                          >
                            <Box display="flex" gap="0 53px">
                              <Box display="flex">
                                <FormControlLabel
                                  variant="standard"
                                  value="false"
                                  control={<Radio />}
                                  label={
                                    <Box color="#000" lineHeight="1">
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n01.lbl25',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                              <Box>
                                <FormControlLabel
                                  variant="standard"
                                  value="true"
                                  control={<Radio />}
                                  label={
                                    <Box color="#000" lineHeight="1">
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n01.lbl26',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                            </Box>
                          </RadioGroup>
                        )}
                        control={control}
                        name="memberLimit"
                      />
                    </Box>
                  </Box>
                  {/*每人限领次数*/}
                  <Box width="100%" mt={5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      <span style={{ color: 'red' }}>*</span>{' '}
                      {formatMessage({ id: 'coupon.mgt.volume.n01.rdo27' })}
                    </Box>
                    <Box display="flex">
                      <Controller
                        render={(pr) => (
                          <RadioGroup
                            className="checkbox-radio-disabled-color"
                            aria-label="isLimitMaxCoupons"
                            onChange={(e) => {
                              setLimitGetNumberRadioState(e.target.value);
                              return pr.onChange(e.target.value);
                            }}
                            value={
                              limitGetNumberRadioState ??
                              deLimitGetNumberRadioState
                            }
                          >
                            <Box display="flex" gap="0 53px">
                              <Box display="flex">
                                <FormControlLabel
                                  variant="standard"
                                  value="false"
                                  control={<Radio />}
                                  label={
                                    <Box color="#000" lineHeight="1">
                                      {formatMessage({
                                        id: 'coupon.mgt.volume.n01.lbl28',
                                      })}
                                    </Box>
                                  }
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                              <Box>
                                <FormControlLabel
                                  variant="standard"
                                  value="true"
                                  control={<Radio />}
                                  label=""
                                  disabled={queryType === 'detail'}
                                />
                              </Box>
                            </Box>
                          </RadioGroup>
                        )}
                        control={control}
                        name="isLimitMaxCoupons"
                      />
                      <Box maxWidth="140px" display="flex" alignItems="center">
                        {couponUsingThreshold({
                          field: 'maxCouponsPerUser',
                          unit: formatMessage({
                            id: 'coupon.mgt.volume.n01.lbl30',
                          }),
                          required:
                            (limitGetNumberRadioState ??
                              deLimitGetNumberRadioState) === 'true',
                          message:
                            (limitGetNumberRadioState ??
                              deLimitGetNumberRadioState) === 'true'
                              ? formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt59',
                                })
                              : '',
                          disabled: !(
                            (limitGetNumberRadioState ??
                              deLimitGetNumberRadioState) === 'true' ||
                            queryType === 'detail'
                          ),
                        })}
                      </Box>
                    </Box>
                  </Box>
                  {/*分享设置*/}
                  <Box display="flex">
                    <Box mt={5} className="checkbox-radio-disabled-color">
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        {formatMessage({
                          id: 'coupon.mgt.volume.n01.chb31',
                        })}
                      </Box>
                      <Controller
                        render={(pr) => (
                          <FormControlLabel
                            variant="standard"
                            checked={
                              shareSettingStatusState ??
                              deShareSettingStatusState
                            }
                            control={<Checkbox color="primary" />}
                            label={
                              <Box color="#000">
                                {formatMessage({
                                  id: 'coupon.mgt.volume.n01.lbl32',
                                })}
                              </Box>
                            }
                            onChange={(e) => {
                              setShareSettingStatusState(e.target.checked);
                              return pr.onChange(e.target.checked);
                            }}
                            disabled={queryType === 'detail'}
                          />
                        )}
                        control={control}
                        name="canShare"
                      />
                    </Box>
                  </Box>
                  {/*转增设置*/}
                  <Box display="flex">
                    <Box mt={5} className="checkbox-radio-disabled-color">
                      <Box
                        fontSize="14px"
                        fontWeight="400"
                        color="#000"
                        mb={1.6}
                      >
                        {formatMessage({
                          id: 'coupon.mgt.volume.n01.chb33',
                        })}
                      </Box>
                      {/* 优惠券允许转增给好友 */}
                      <Controller
                        render={(pr) => (
                          <FormControlLabel
                            variant="standard"
                            checked={turnAddStatusState ?? deTurnAddStatusState}
                            control={<Checkbox color="primary" />}
                            label={
                              <Box color="#000">
                                {formatMessage({
                                  id: 'coupon.mgt.volume.n01.lbl34',
                                })}
                              </Box>
                            }
                            onChange={(e) => {
                              setTurnAddStatusState(e.target.checked);
                              return pr.onChange(e.target.checked);
                            }}
                            disabled={queryType === 'detail'}
                          />
                        )}
                        control={control}
                        name="transferable"
                      />
                    </Box>
                  </Box>
                  {/*使用条件*/}
                  <Box width="100%" mt={5}>
                    <Box fontSize="14px" fontWeight="400" color="#000" mb={1.6}>
                      {formatMessage({ id: 'coupon.mgt.volume.n01.chb35' })}
                    </Box>
                    <Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsOneState ??
                                deCouponConditionsOneState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl36',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsOneState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isOver"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsTwoState ??
                                deCouponConditionsTwoState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl37',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsTwoState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isMemberDiscount"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsThreeState ??
                                deCouponConditionsThreeState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl38',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsThreeState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isActivityOver"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsFourState ??
                                deCouponConditionsFourState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl39',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsFourState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isNonPositive"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsFiveState ??
                                deCouponConditionsFiveState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl40',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsFiveState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isStaff"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsSixState ??
                                deCouponConditionsSixState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl41',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsSixState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isPoint"
                        />
                      </Box>
                      <Box className="checkbox-radio-disabled-color">
                        <Controller
                          render={(pr) => (
                            <FormControlLabel
                              variant="standard"
                              checked={
                                couponConditionsSevenState ??
                                deCouponConditionsSevenState
                              }
                              control={<Checkbox color="primary" />}
                              label={
                                <Box color="#000">
                                  {formatMessage({
                                    id: 'coupon.mgt.volume.n01.lbl42',
                                  })}
                                </Box>
                              }
                              onChange={(e) => {
                                setCouponConditionsSevenState(e.target.checked);
                                return pr.onChange(e.target.checked);
                              }}
                              disabled={queryType === 'detail'}
                            />
                          )}
                          control={control}
                          name="isRank"
                        />
                      </Box>
                    </Box>
                  </Box>
                  {/*限制订单内商品件数*/}
                  {cType !== '3' && (
                    <>
                      <Box width="100%" mt={5}>
                        <Box
                          fontSize="14px"
                          fontWeight="400"
                          color="#000"
                          mb={1.6}
                        >
                          {formatMessage({
                            id: 'coupon.mgt.volume.n01.lbl43',
                          })}
                        </Box>
                        <Box maxWidth="214px">
                          {couponUsingThreshold({
                            field: 'goodsNum',
                            unit: formatMessage({
                              id: 'coupon.mgt.volume.n01.lbl44',
                            }),
                          })}
                        </Box>
                      </Box>
                      {/*tips*/}
                      <Box
                        color="#C9C9C9"
                        fontSize="14px"
                        fontWeight="400"
                        mt={1.75}
                        mb={5}
                      >
                        {formatMessage({
                          id: 'coupon.mgt.pricevalue.n01.txt60',
                        })}
                      </Box>
                    </>
                  )}
                  {/*优惠券名称*/}
                  <Box width="100%" maxWidth="333px" mt={5}>
                    <Controller
                      render={(pr) => (
                        <TextField
                          multiline
                          rows={12}
                          id="outlined-multiline-static"
                          label={
                            <>
                              <span style={{ color: 'red' }}>*</span>{' '}
                              {formatMessage({
                                id: 'coupon.mgt.volume.n01.lbl45',
                              })}
                            </>
                          }
                          value={pr.value || ''}
                          placeholder={formatMessage({
                            id: 'coupon.mgt.pricevalue.n01.txt61',
                          })}
                          className="text-input-style textField-area-wrap"
                          onChange={(e) => {
                            return pr.onChange(e.target.value);
                          }}
                          variant="outlined"
                          error={Boolean(errors.description)}
                          helperText={
                            errors.description
                              ? formatMessage({
                                  id: 'coupon.mgt.pricevalue.n01.txt62',
                                })
                              : ''
                          }
                          disabled={queryType === 'detail'}
                        />
                      )}
                      control={control}
                      name="description"
                      rules={{
                        required: true,
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
        </form>
      </Box>
    );
  },
);
